export enum DistanceUnit {
  KILOMETERS = 'kilometers',
  MILES = 'miles',
  METERS = 'meters',
  FEET = 'feet'
}
